import React, {useEffect, useState} from 'react';
import SEO from '../Components/SEO';
import { createClient } from 'contentful';
import { transformEntryFields, tokenReplace } from '../../utils/tokenReplace';
import { useParams } from 'react-router-dom';
import HeroCasino from '../Components/Casinos/HeroCasino';
import Content from '../Components/Content';
import ArticleInfo from '../Components/Article/ArticleInfo';
import TableOfContent from '../Components/TableOfContent';
import AuthorCard from '../Components/Author/AuthorCard';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Rating, ThinStar } from '@smastrom/react-rating'
import '@smastrom/react-rating/style.css';
import person from '../../assets/img/person.png';

const Casino = () => {

  const [singleEntry, setSingleEntry] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const customStyles = {
    itemShapes: ThinStar,
    activeFillColor: '#FFC93A',
    inactiveFillColor: '#A5A2B2',
  };

  //   function getRating(rating) {
  //   switch (rating) {
  //     case 1:
  //       return 'Poor';
  //     case 2:
  //       return 'Nothing special';
  //     case 3:
  //       return 'Average';
  //     case 4:
  //       return 'Very good';
  //     case 5:
  //       return 'Excellent';
  //     default:
  //       return '';
  //   }
  // }

  const [rating, setRating] = useState(0);


  const client = createClient({
    space: 'qzvdhv6dk1nu',
    environment: 'master',
    accessToken: 'yF08NDjz2PAvDXY7SsJ57o2vkwpxT1zOjunvfbNOx_4'
  })

  let { slug } = useParams();

  useEffect(() => {
    const getEntries = async () => {
      try {
        const entries = await client.getEntries({
          content_type: "casino",
          limit: 1,
          "fields.slug": slug,
        });
        
        // 3) Transform each item’s fields so tokens get replaced
        entries.items.forEach((item) => {
          transformEntryFields(item);
        });

        console.log(entries);

        setSingleEntry(entries);
        setIsDataLoaded(true);
      } catch (error) {
        console.error(error);
      }
    };
    getEntries();
  }, [slug]);

  const richTextOptions = {
    renderText: text => tokenReplace(text),
  };

  return (
    <div className="container-fluid">
      {singleEntry?.items?.map((singleEntry) =>
        <div key={singleEntry?.sys?.id}>
          <SEO
          title={
            singleEntry?.fields?.legalInDeutschland ?
              singleEntry?.fields?.seoFields?.fields?.metaTitle ? 
                singleEntry?.fields?.seoFields?.fields?.metaTitle 
              : singleEntry?.fields?.title + ' | Casinos Vergleich'
            : singleEntry?.fields?.seoFields?.fields?.metaTitle + ' - Vorsicht bei diesem Casino! | Casinos Vergleich'}
          metaTitle={
            singleEntry?.fields?.legalInDeutschland ?
              singleEntry?.fields?.seoFields?.fields?.metaTitle ? 
                singleEntry?.fields?.seoFields?.fields?.metaTitle + ' | Casinos Vergleich' 
              : singleEntry?.fields?.title + ' | Casinos Vergleich'
            : singleEntry?.fields?.seoFields?.fields?.metaTitle + ' - Vorsicht bei diesem Casino! | Casinos Vergleich'}
          description={
            singleEntry?.fields?.legalInDeutschland ?
              singleEntry?.fields?.seoFields?.fields?.metaDescription ? 
                singleEntry?.fields?.seoFields?.fields?.metaDescription 
              : 'Ist ' + singleEntry?.fields?.title + ' illegal in Deutschland? ✓ Was ist der höchste Bonus aktuell? ✓ Welche Erfahrungen haben User? Jetzt entdecken!'
            : 'Finger weg von diesem Casino! Das haben unsere Experten über die Boni und mehr des neuen Anbieters ' + singleEntry?.fields?.seoFields?.fields?.metaTitle ? 
            singleEntry?.fields?.seoFields?.fields?.metaTitle 
          : singleEntry?.fields?.title + ' herausgefunden.'}
          author={singleEntry?.fields?.author?.fields?.name}
          />
          <HeroCasino 
          title={singleEntry?.fields?.title}
          featuredImage={singleEntry?.fields?.featuredImage?.fields?.file?.url + '?h=140'}
          bonus={singleEntry?.fields?.bonus}
          rtp={singleEntry?.fields?.rtp}
          zUser={singleEntry?.fields?.zufriedeneUser}
          externalLink={singleEntry?.fields?.externalLinkToCasino}
          idx={singleEntry?.fields?.slug}
          rating={singleEntry?.fields?.rating}
          ratingStyles={customStyles}
          logoBg={singleEntry?.fields?.logoBackground}
          follow={singleEntry?.fields.jetztSpielenShow ? singleEntry?.fields.jetztSpielenShow : ''}
          popupCasino={singleEntry?.fields?.popupCasino ? singleEntry?.fields?.popupCasino : ''}
          pt={singleEntry?.fields?.popupTitle}
          plp={singleEntry?.fields?.popupLinkProminent ? singleEntry?.fields?.popupLinkProminent : ''}
          pl={singleEntry?.fields?.popupLink ? singleEntry?.fields?.popupLink : ''}
          ></HeroCasino>

          {/* Container */}       
          <div className="container row m-auto flex-column-reverse flex-lg-row px-0">

            {/*Main Content*/}
            <main className="contentclass col-12 col-lg-8">
            { isDataLoaded ? 
            <ArticleInfo
            name = {singleEntry?.fields?.author?.fields?.name}
            avatar = {singleEntry?.fields?.author?.fields?.avatar ? singleEntry?.fields?.author?.fields?.avatar?.fields?.file?.url + '?h=30' : person}
            slug = {'autor/' + singleEntry?.fields?.author?.fields?.slug}
            createdAt = {new Date(singleEntry?.sys?.createdAt).toLocaleDateString("en-GB")}
            updatedAt = {new Date(singleEntry?.sys?.updatedAt).toLocaleDateString("en-GB")}>
            </ArticleInfo>
            : null }

            { isDataLoaded ? <Content id={singleEntry?.sys?.id}></Content> : null }

            <AuthorCard
            name = {singleEntry?.fields?.author?.fields?.name}
            avatar = {singleEntry?.fields?.author?.fields?.avatar?.fields?.file?.url + '?h=100'}
            slug = {'autor/' + singleEntry?.fields?.author?.fields?.slug}
            excerpt = {documentToReactComponents(singleEntry?.fields?.author?.fields?.bio)}></AuthorCard>

            </main>
            {/*end::Main Content*/}

            {/*Sidebar*/}
            <div className="col-12 col-lg-4">
            <TableOfContent></TableOfContent>
            </div>
            {/*end::Sidebar*/}

          </div>
          {/* end::Container */}


        </div>
          )}
    </div>
  )
  
}

export default Casino